'use client'

import { useSignUpModal } from '@/hooks/use-sign-up-modal'
import s from './create-account-banner.module.css'
import { useUser } from '@/hooks/use-user'
import { ButtonV4 } from '@/components/v4/atoms/button/button'

export const CreateAccountBanner = () => {
  const signUpModal = useSignUpModal()
  const { user } = useUser()

  const handleOnClickCreateAccount = () => {
    signUpModal.open()
  }

  if (user) return null

  return (
    <div className={s.wrapper}>
      <div className={s.headerWrapper}>
        <div className={s.header}>
          Top trends, dreamy venues, and expert advice.
        </div>
        <div className={s.subHeader}>
          Saved to your dashboard and delivered straight to your{' '}
          <span className={s.decoratedText}>inbox</span>{' '}
        </div>
      </div>
      <ButtonV4 variant="light" onClick={handleOnClickCreateAccount} className={s.button}>
        SIGN UP NOW
      </ButtonV4>
    </div>
  )
}
